export default "__VITE_PUBLIC_ASSET__1a1550b1__"